import { type FirebaseOptions, initializeApp } from "firebase/app";

// const firebaseConfig: FirebaseOptions = {
//   apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
//   authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
//   measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
// };

// TODO: Temporarily hardcoded Firebase config for development purposes.
const firebaseConfig: FirebaseOptions = {
  apiKey: "AIzaSyALbOsl37GVnDhMZejDNd3ZWgYcOWD2tEI",
  authDomain: "piperunner-cms.firebaseapp.com",
  projectId: "piperunner-cms",
  storageBucket: "piperunner-cms.firebasestorage.app",
  messagingSenderId: "97135918543",
  appId: "1:97135918543:web:53959bf9d5ea08c8e6a6ba",
  measurementId: "G-FNP2CXEPNL",
};

// Initialize Firebase
export const app = (() => {
  console.log("Initializing Firebase");
  return initializeApp(firebaseConfig);
})();
